export const environment = {
  production: false,
  //appVersion: require('../../package.json').version,
  apiEndpoint: 'https://api.dev.limpiezapp.derichebourg-multiservices.com',
  graphApiEndpoint: 'https://graph.microsoft.com',
  auth: {
    authority: 'https://login.microsoftonline.com/0e3d950c-f028-43ec-963b-c060275e6bbc',
    clientId: 'dd1993c2-69ae-495d-8895-441e2d3ecaa9',
    redirectUri: 'https://app.dev.limpiezapp.derichebourg-multiservices.com',
    postLogoutRedirectUri: 'https://app.dev.limpiezapp.derichebourg-multiservices.com/',
    apiScopes: ['api://eccc6092-a423-47c7-abfb-861283f70a7a/fullaccess'],
    graphApiScopes: ['User.Read', 'User.ReadBasic.All'],
    loginFailedRoute: '/login-failed',
  },
};
